// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let WizardNavigationVisuals = require("../wizard/WizardNavigationVisuals.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts = require("./PropertyWizardFormRelay__Validators__KeyFacts.bs.js");
let PropertyWizardFormRelay__Validators__Showings = require("./PropertyWizardFormRelay__Validators__Showings.bs.js");
let PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
let PropertyWizardRelayNavigation_formState_graphql = require("../../../__generated__/PropertyWizardRelayNavigation_formState_graphql.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
let PropertyWizardRelayNavigation_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayNavigation_localDraft_graphql.bs.js");
let PropertyWizardFormRelay__Validators__PhotosAndFiles = require("./PropertyWizardFormRelay__Validators__PhotosAndFiles.bs.js");

function PropertyWizardRelayNavigation$ListItem(props) {
  let selectStep = props.selectStep;
  let markStepAsTouched = props.markStepAsTouched;
  let activeStep = props.activeStep;
  let step = props.step;
  let wrapInTouchedOrActive = (innerState, step) => {
    if (activeStep === step) {
      return {
        NAME: "active",
        VAL: innerState
      };
    } else {
      return {
        NAME: "touched",
        VAL: innerState
      };
    }
  };
  return JsxRuntime.jsx(WizardNavigationVisuals.Item.make, {
    active: activeStep === step,
    icon: props.icon,
    label: props.label,
    stepState: props.stepTouched ? (
        props.stepValid ? wrapInTouchedOrActive("valid", step) : wrapInTouchedOrActive("invalid", step)
      ) : (
        activeStep === step ? ({
            NAME: "active",
            VAL: "unknown"
          }) : "untouched"
      ),
    stepNumber: props.stepNumber,
    onClick: e => {
      e.preventDefault();
      markStepAsTouched();
      selectStep(step);
    }
  });
}

let ListItem = {
  make: PropertyWizardRelayNavigation$ListItem
};

let convertFragment = PropertyWizardRelayNavigation_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayNavigation_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayNavigation_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayNavigation_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayNavigation_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayNavigation_localDraft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayNavigation_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayNavigation_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayNavigation_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayNavigation_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayNavigation_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayNavigation_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function stepValid(valid) {
  return valid !== "Invalid";
}

function PropertyWizardRelayNavigation(props) {
  let activeStep = props.activeStep;
  let selectStep = props.selectStep;
  let match = PropertyWizardFormRelay.Context.use();
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayNavigation_localDraft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayNavigation_formState_graphql.node, convertFragment$1, props.formState);
  let updateFormState = PropertyWizardFormRelay.FormState.useUpdater();
  let keyFactsValid = PropertyWizardFormRelay__Validators__KeyFacts.use(draft.fragmentRefs, formState.fragmentRefs);
  let descriptionValid = PropertyWizardFormRelay__Validators__Description.use(draft.fragmentRefs, formState.fragmentRefs);
  let mlsTimingValid = PropertyWizardFormRelay__Validators__MLSTiming.use(draft.fragmentRefs, formState.fragmentRefs);
  let showingsValid = PropertyWizardFormRelay__Validators__Showings.use(draft.fragmentRefs);
  let photosAndFilesValid = PropertyWizardFormRelay__Validators__PhotosAndFiles.use(formState.fragmentRefs);
  let markStepAsTouched = () => updateFormState(formState => {
    if (activeStep === "description") {
      formState.stepDescriptionTouched = true;
    } else if (activeStep === "mlsTiming") {
      formState.stepMlsTimingTouched = true;
    } else if (activeStep === "photosAndFiles") {
      formState.stepPhotosAndFilesTouched = true;
    } else if (activeStep === "keyFacts") {
      formState.stepKeyFactsTouched = true;
    } else {
      formState.stepShowingsTouched = true;
    }
  });
  let tmp;
  let tmp$1 = match.mode;
  tmp = typeof tmp$1 !== "object" || tmp$1.TAG !== "Rebroadcast" ? "Description" : "Message";
  let match$1 = draft.draftProperty.propertyType;
  let tmp$2;
  tmp$2 = match$1 === "FOR_SALE" ? JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
      step: "showings",
      activeStep: activeStep,
      icon: "eye",
      label: "Showings",
      stepTouched: formState.stepShowingsTouched,
      stepValid: showingsValid !== "Invalid",
      stepNumber: 4,
      markStepAsTouched: markStepAsTouched,
      selectStep: selectStep
    }) : null;
  return JsxRuntime.jsx(WizardNavigationVisuals.Holder.make, {
    children: JsxRuntime.jsxs(WizardNavigationVisuals.List.make, {
      children: [
        JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
          step: "keyFacts",
          activeStep: activeStep,
          icon: "file",
          label: "Key facts",
          stepTouched: formState.stepKeyFactsTouched,
          stepValid: keyFactsValid !== "Invalid",
          stepNumber: 1,
          markStepAsTouched: markStepAsTouched,
          selectStep: selectStep
        }),
        JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
          step: "mlsTiming",
          activeStep: activeStep,
          icon: "clock",
          label: "MLS timing",
          stepTouched: formState.stepMlsTimingTouched,
          stepValid: mlsTimingValid !== "Invalid",
          stepNumber: 2,
          markStepAsTouched: markStepAsTouched,
          selectStep: selectStep
        }),
        JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
          step: "description",
          activeStep: activeStep,
          icon: "pencil",
          label: tmp,
          stepTouched: formState.stepDescriptionTouched,
          stepValid: descriptionValid !== "Invalid",
          stepNumber: 3,
          markStepAsTouched: markStepAsTouched,
          selectStep: selectStep
        }),
        tmp$2,
        JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
          step: "photosAndFiles",
          activeStep: activeStep,
          icon: "image",
          label: "Photos & files",
          stepTouched: formState.stepPhotosAndFilesTouched,
          stepValid: photosAndFilesValid !== "Invalid",
          stepNumber: 5,
          markStepAsTouched: markStepAsTouched,
          selectStep: selectStep
        })
      ]
    })
  });
}

let Icon;

let FormState;

let Utils;

let Validators;

let make = PropertyWizardRelayNavigation;

exports.Icon = Icon;
exports.FormState = FormState;
exports.Utils = Utils;
exports.ListItem = ListItem;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.Validators = Validators;
exports.stepValid = stepValid;
exports.make = make;
/* react/jsx-runtime Not a pure module */
